const images = {
  brand: {
    favicon: "/Westlisoft.png",
    logo: "/Logos/Westlisoft logo.png",
    logoEncoded: "/Logos/Westlisoft%20logo.png",
    logoWhiteOnly: "/Logos/logo_white_only.png",
    logoWhiteClean: "/Logos/logo_white_clean.png",
  },

  pages: {
    about: "/Images/About Us.png",
    aiDataOperations: "/Images/AI Data Operations.png",
    applicationDevelopment: "/Images/Application Development.png",
    blog: "/Images/Blog.png",
    contact: "/Images/Contact Us.png",
    corporateTrainingAdvancement:
      "/Images/Corporate Training & Advancement.png",
    digitalMarketing: "/Images/Digital Marketing.png",
    disclaimer: "/Images/Disclaimer.png",
    faqs: "/Images/FAQ's.png",
    ourIndustries: "/Images/Our Industries.png",
    ourServices: "/Images/Our Services.png",
    privacyPolicy: "/Images/Privacy Policy.png",
    rcmServices: "/Images/RCM Services.png",
    staffingService: "/Images/Staffing Service.png",
    talentContinuityManagement: "/Images/Talent Continuity Management.png",
    termsConditions: "/Images/Terms & Conditions.png",
    toursTravels: "/Images/Tours & Travels.png",
  },

  applicationDevelopmentServices: {
    webApplicationDevelopment: "/Images/Web Application Development.png",
    mobileAppDevelopment: "/Images/Mobile App Development.png",
    customSoftwareSolutions: "/Images/Custom Software Solutions.png",
    uiuxDesign: "/Images/UIUX Design.png",
    apiIntegration: "/Images/API Integration.png",
    maintenanceSupport: "/Images/Maintenance & Support.png",
  },

  rcmServiceSolutions: {
    medicalBilling: "/Images/Medical Billing.png",
    claimsProcessing: "/Images/Claims Processing.png",
    releaseOfInformation: "/Images/Release of Information (ROI).png",
    eligibilityVerification: "/Images/Eligibility Verification.png",
    denialManagement: "/Images/Denial Management.png",
    accountsReceivableManagement:
      "/Images/Accounts Receivable (AR) Management.png",
  },

  aiDataOperationServices: {
    annotation: "/Images/Annotation.png",
    transcription: "/Images/Transcription.png",
    rlhf: "/Images/RLHF.png",
    voiceVideoDatasetCreation: "/Images/Voice & Video Dataset Creation.png",
  },

  digitalMarketingServices: {
    seo: "/Images/Search Engine Optimization (SEO).png",
    socialMediaMarketing: "/Images/Social Media Marketing.png",
    performanceMarketing: "/Images/Performance Marketing.png",
    contentMarketing: "/Images/Content Marketing.png",
    brandingSolutions: "/Images/Branding Solutions.png",
    leadGeneration: "/Images/Lead Generation.png",
  },

  staffingServices: {
    itStaffing: "/Images/IT Staffing.png",
    permanentStaffing: "/Images/Permanent Staffing.png",
    contractStaffing: "/Images/Contract Staffing.png",
    remoteResourceHiring: "/Images/Remote Resource Hiring.png",
    workforceManagement: "/Images/Workforce Management.png",
  },

  industries: {
    banking: "/Images/Banking.png",
    ecommerce: "/Images/E-commerce.png",
    education: "/Images/Education.png",
    finance: "/Images/Finance.png",
    healthcare: "/Images/Healthcare.png",
    manufacturing: "/Images/Manufacturing.png",
  },

  people: {
    kalpana: "/Images/kalpana.png",
    krishnaChaitanya: "/Images/krishna-chaitnya.jpeg",
    smileyBusinesswoman: "/Images/smiley-businesswoman-posing-outdoors.jpg",
    multitaskingGroup: "/Images/variety-people-multitasking-3d-cartoon.jpg",
  },

  clientLogos: {
    amazon: "/Logos/Amazon.png",
    fint: "/Logos/FINT.png",
    flipkart: "/Logos/Flipkart.png",
    forasoft: "/Logos/Forasoft.png",
    landT: "/Logos/L&T.png",
    logitech: "/Logos/LogiTech.png",
    tata: "/Logos/TATA.png",
    tcs: "/Logos/TCS.png",
  },

  trainingIcons: {
    java: "https://img.icons8.com/ios/50/java-coffee-cup-logo--v1.png",
    python: "https://img.icons8.com/ios/50/python--v1.png",
    bot: "https://img.icons8.com/softteal-line/24/bot.png",
    erp: "https://img.icons8.com/external-glyph-design-circle/66/external-Erp-Transactions-artificial-intelligence-solid-design-circle.png",
  },
};

export default images;
